<template>
  <transition name="slide-fade">
    <div v-if="!consentAnswered" class="cookie-consent-banner">
      <div class="cookie-content">
        <div class="cookie-icon">
          <i class="pi pi-info-circle"></i>
        </div>
        <div class="cookie-text">
          <h3>Preferencias de Cookies</h3>
          <p>Usamos cookies para personalizar anuncios y medir estadísticas. ¿Aceptas que Gogo personalice tu experiencia?</p>
        </div>
      </div>
      <div class="cookie-actions">
        <button class="btn-decline" @click="handleConsent(false)">Rechazar</button>
        <button class="btn-accept" @click="handleConsent(true)">Aceptar</button>
      </div>
    </div>
  </transition>
</template>

<script>
import { consentAnswered, updateConsent } from '../services/consentService';

export default {
  name: "CookieConsent",
  setup() {
    const handleConsent = (granted) => {
      updateConsent(granted);
    };

    return {
      consentAnswered,
      handleConsent
    };
  }
};
</script>

<style scoped>
.cookie-consent-banner {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  width: 90vw;
  max-width: 580px;
  background: rgba(20, 20, 20, 0.9);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  z-index: 99999;
}

@media (min-width: 640px) {
  .cookie-consent-banner {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 1.25rem 2rem;
  }
}

.cookie-content {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.cookie-icon {
  font-size: 1.5rem;
  color: #7289da; /* Azul Blurple oficial del Hero/Discord */
  margin-top: 0.15rem;
}

.cookie-text h3 {
  margin: 0 0 0.25rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #ffffff;
}

.cookie-text p {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.4;
  color: #cbd5e1; /* slate-300 */
}

.cookie-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  justify-content: flex-end;
}

@media (min-width: 640px) {
  .cookie-actions {
    width: auto;
  }
}

.cookie-actions button {
  padding: 0.6rem 1.25rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-accept {
  background: #7289da; /* Azul Blurple a juego con el tema del sitio */
  color: #ffffff;
  border: none;
  box-shadow: 0 4px 12px rgba(114, 137, 218, 0.3);
}

.btn-accept:hover {
  background: #5b6eae; /* Hover oficial a juego con .discord-btn */
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(114, 137, 218, 0.4);
}

.btn-accept:active {
  transform: translateY(0);
}

.btn-decline {
  background: transparent;
  color: #94a3b8; /* slate-400 */
  border: 1px solid rgba(255, 255, 255, 0.15);
}

.btn-decline:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.3);
}

/* Animations */
.slide-fade-enter-active {
  transition: all 0.4s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.3s ease-in;
}
.slide-fade-enter-from {
  transform: translate(-50%, 30px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translate(-50%, 20px);
  opacity: 0;
}
</style>
